import { css } from '@emotion/react'
import { HFlow, Text, VFlow } from 'bold-ui'
import { MChatPerguntaEnum } from 'graphql/types.generated'

import { getMChatPerguntaNumber } from '../../mchat/utils-mchat'
import { ConsultaSeguimentoPerguntaStatusEnum } from '../enums-consultaSeguimento'
import { CONSULTA_SEGUIMENTO_PERGUNTA_STATUS } from '../model-consultaSeguimento'

interface ConsultaSeguimentoModalStepperPerguntaStatusProps {
  pergunta: MChatPerguntaEnum
  status: ConsultaSeguimentoPerguntaStatusEnum
}

export function ConsultaSeguimentoModalStepperPerguntaStatus(
  props: Readonly<ConsultaSeguimentoModalStepperPerguntaStatusProps>
) {
  const { pergunta, status } = props

  const { icon, label } = CONSULTA_SEGUIMENTO_PERGUNTA_STATUS[status]

  return (
    <HFlow hSpacing={0.5} style={styles.root}>
      <div css={styles.iconContainer}>{icon}</div>
      <VFlow vSpacing={0}>
        <Text
          color={status === ConsultaSeguimentoPerguntaStatusEnum.NAO_DISPONIVEL ? 'secondary' : 'normal'}
          css={styles.label}
        >
          Pergunta {getMChatPerguntaNumber(pergunta)}
        </Text>
        {label}
      </VFlow>
    </HFlow>
  )
}

const styles = {
  root: css`
    padding: 0.25rem 0;
    grid-auto-columns: 1rem 1fr;
    display: flex;
  `,
  iconContainer: css`
    padding-top: 0.25rem;
  `,
  label: css`
    height: 1.5rem;
    display: inline-flex;
    align-items: center;
  `,
}
